"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var chunkPBLNC4OF_js = require('./chunk-PBLNC4OF.js');
var react = require('react');
var r = require('styled-components');
var reactSelect = require('@radix-ui/react-select');
var faAngleDown = require('@fortawesome/pro-solid-svg-icons/faAngleDown');
var faAngleUp = require('@fortawesome/pro-solid-svg-icons/faAngleUp');
var faCircleNotch = require('@fortawesome/pro-solid-svg-icons/faCircleNotch');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var r__default = /*#__PURE__*/_interopDefaultLegacy(r);

var h=r__default["default"](reactSelect.SelectIcon)`
  display: flex;
`,n=r__default["default"](chunkPBLNC4OF_js.b).attrs({icon:faAngleDown.faAngleDown})`
  color: var(--foreground-secondary);
  margin-left: var(--spacing-regular);
`,x=r__default["default"](chunkPBLNC4OF_js.b).attrs({icon:faCircleNotch.faCircleNotch,spin:!0})`
  color: var(--foreground-secondary);
  margin-left: var(--spacing-regular);
`,i=r__default["default"].div`
  align-items: center;
  color: var(--foreground-primary);
  cursor: default;
  display: flex;
  gap: var(--spacing-small);
  line-height: var(--line-height-regular);

  > ${chunkPBLNC4OF_js.b} {
    color: var(--foreground-secondary);
    min-width: 18px;
  }

  /* Currently selected item */
  &[data-state='checked'] {
    color: var(--foreground-selected);
    font-weight: var(--font-weight-bold);

    > ${chunkPBLNC4OF_js.b} {
      color: var(--foreground-selected);
    }
  }
`,$=r__default["default"](reactSelect.Trigger)`
  align-items: center;
  background-color: var(--background-level-1);
  border: var(--border-width-x-small) solid var(--border-input-default);
  border-radius: var(--border-radius-small);
  display: flex;
  font-size: ${e=>e.$size==="small"?"var(--font-size-small)":"var(--font-size-regular)"};
  line-height: ${e=>e.$size==="small"?"var(--line-height-large)":"var(--line-height-regular)"};
  min-height: 42px;
  padding: var(--spacing-small) var(--spacing-regular);
  padding-left: calc(var(--spacing-regular) - 1px);
  ${e=>e.$width==="full-width"&&"width: 100%;"}
  ${e=>e.$width==="fit-content"&&"width: fit-content;"}

  & span:first-child {
    flex: 1;
    text-align: left;
  }

  ${n} {
    float: right;
    font-size: ${e=>e.$size==="small"?"var(--icon-size-small)":"var(--icon-size-regular)"};
  }

  /* Placeholder text */
  &[data-placeholder] {
    color: var(--foreground-input-placeholder);
    font-size: ${e=>e.$size==="small"?"var(--font-size-small)":"var(--font-size-regular)"};
    font-style: italic;
  }

  /* Disabled state */
  &[data-disabled] {
    background-color: var(--background-input-disabled);
    border-color: var(--border-input-disabled);
    cursor: not-allowed;

    ${n},
    ${i},
    ${i} ${chunkPBLNC4OF_js.b},
    &[data-placeholder] {
      color: var(--foreground-disabled);
    }
  }

  /* Hover state */
  &:hover:not([data-disabled]) {
    border-color: var(--border-input-hover);
  }

  &:focus-visible {
    border-color: var(--border-input-active);
    outline: var(--border-width-small) solid var(--border-input-active-outline);
  }

  ${({$error:e})=>e&&`
    border-color: var(--border-input-error);
    outline: var(--border-width-small) solid var(--border-input-error-outline);
  `}
`,S=r__default["default"](reactSelect.Content)`
  background-color: var(--background-level-3);
  border-radius: var(--border-radius-small);
  box-shadow: var(--elevation-300);
  font-size: ${e=>e.$size==="small"?"var(--font-size-small)":"var(--font-size-regular)"};
  gap: var(--spacing-x-small);
  padding: var(--spacing-small) 0;
  z-index: var(--z-index-300);

  ${e=>e.position==="popper"&&`
    width: var(--radix-select-trigger-width);
    max-height: ${e.height?`${e.height}px`:"var(--radix-select-content-available-height)"};
  `}

  ${i} ${chunkPBLNC4OF_js.b} {
    font-size: ${e=>e.$size==="small"?"var(--icon-size-small)":"var(--icon-size-regular)"};
  }
`,w=r__default["default"](reactSelect.Viewport)`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-x-small);
`,y=r__default["default"].div`
  border-radius: var(--border-radius-small);
  padding: var(--spacing-small) var(--spacing-regular);

  /* Hover state */
  &:hover,
  &[data-highlighted] {
    background-color: var(--background-selected);
  }

  &:focus-visible {
    --padding-vertical: calc(var(--spacing-small) - 2px);
    --padding-horizontal: calc(var(--spacing-regular) - 2px);

    border: var(--border-width-small) solid var(--color-blue-600);
    padding: var(--padding-vertical) var(--padding-horizontal);
    outline: none;
  }
`,u=r__default["default"].div`
  cursor: default;
  color: var(--foreground-secondary);
  font-size: var(--font-size-small);
`,z=r__default["default"](reactSelect.Item)`
  border-radius: var(--border-radius-small);

  &[data-disabled] {
    pointer-events: none;

    ${i}, ${u} {
      color: var(--foreground-disabled);
    }
  }

  &:focus-visible {
    outline: var(--border-width-small) solid var(--border-input-active-outline);
    outline-offset: -2px;
  }
`,I=r.css`
  align-items: center;
  color: var(--foreground-secondary);
  cursor: default;
  display: flex;
  justify-content: center;
`,P=r__default["default"](reactSelect.ScrollUpButton).attrs({children:jsxRuntime.jsx(chunkPBLNC4OF_js.b,{icon:faAngleUp.faAngleUp})})`
  ${I}
`,T=r__default["default"](reactSelect.ScrollDownButton).attrs({children:jsxRuntime.jsx(chunkPBLNC4OF_js.b,{icon:faAngleDown.faAngleDown})})`
  ${I}
`;var C=react.forwardRef(({ariaLabel:e="",ariaLabelledBy:d="",children:c,className:a,disabled:p=!1,error:l=!1,id:g,container:m=document.body,placeholder:k,size:f="regular",showLoadingIndicator:A=!1,width:V="fit-content",position:H="popper",height:N,onKeyDown:O,...R},E)=>jsxRuntime.jsxs(reactSelect.Root,{...R,children:[jsxRuntime.jsxs($,{"aria-label":e,"aria-labelledby":d,className:a,disabled:p,id:g,$error:l,$size:f,$width:V,ref:E,onKeyDown:O,children:[jsxRuntime.jsx(reactSelect.Value,{placeholder:k}),jsxRuntime.jsx(h,{children:A?jsxRuntime.jsx(x,{}):jsxRuntime.jsx(n,{})})]}),jsxRuntime.jsx(reactSelect.Portal,{container:m,children:jsxRuntime.jsxs(S,{$size:f,position:H,sideOffset:4,height:N,children:[jsxRuntime.jsx(P,{}),jsxRuntime.jsx(w,{children:c}),jsxRuntime.jsx(T,{})]})})]}));C.displayName="Select";var re=r__default["default"](C)``;var L=react.forwardRef(({icon:e,label:d,hoverText:c="",description:a="",disabled:p=!1,value:l,leftDecorator:g},m)=>jsxRuntime.jsx(z,{value:l,ref:m,disabled:p,children:jsxRuntime.jsxs(y,{children:[jsxRuntime.jsx(reactSelect.ItemText,{title:c,children:jsxRuntime.jsxs(i,{children:[g,e&&jsxRuntime.jsx(chunkPBLNC4OF_js.b,{icon:e}),d]})}),a&&jsxRuntime.jsx(u,{children:a})]})},l));L.displayName="SelectOption";var ie=L;

exports.a = re;
exports.b = ie;
